module.exports = __webpack_public_path__ + "static/media/note-card-asset.58abbcb5.png";